var _class;
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
import { action } from '@ember/object';
import Component from '@glimmer/component';
let BaseForm = (_class = class BaseForm extends Component {
  constructor(owner, args) {
    super(owner, args);
    if (!args.changeset) {
      throw new Error('You must pass a valid @changeset as argument');
    }
  }
  rollback(e) {
    e?.preventDefault();
    this.args.changeset.rollback();
  }
  async submit(e, ...otherArgs) {
    e?.preventDefault();
    await this.args.changeset.validate();
    if (this.args.changeset.isValid) {
      await this.args.saveFunction?.(this.args.changeset, ...otherArgs);
    }
  }
}, (_applyDecoratedDescriptor(_class.prototype, "rollback", [action], Object.getOwnPropertyDescriptor(_class.prototype, "rollback"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "submit", [action], Object.getOwnPropertyDescriptor(_class.prototype, "submit"), _class.prototype)), _class);
export { BaseForm as default };